import React, { useContext } from "react";
import { MANAGE_JOB, MODAL_STATES } from "../../../constant/Home/Jobs";
import Section from "../Details";
import Modal from "../../../Ui/Modal";
import ButtonComponent from "../../../Ui/Button";
import { UserContext } from "../../../context/UserContext";
const CanceledConfirmationComponent = ({ setModalState }) => {
  const { userData } = useContext(UserContext);
  return (
    <Modal
      open={true}
      maxWidth="953px"
      onClose={() => setModalState("")}
      logoDetail="Your job request has been canceled."
      title="Cancel Job"
      footer={
        <div className="flex w-full justify-between">
          <ButtonComponent
            paddingY="10px"
            onClick={() => setModalState(MODAL_STATES.CANCEL_JOB)}
          >
            Back
          </ButtonComponent>
          <ButtonComponent
            bgColor="#D40000"
            color="#FFFFFF"
            hoverBgColor="#B00000"
            hoverBorderColor="#B00000"
            paddingY="10px"
            onClick={() => setModalState("")}
          >
            Exit
          </ButtonComponent>
        </div>
      }
    >
      <p className="text-[20px] max-w-[630px] mx-auto text-[#242424] font-medium min-h-[105px] text-center">
        If you would like the work completed you can submit a new request at any
        time and we will be happy to help you get it done.
      </p>
    </Modal>
  );
};

export default CanceledConfirmationComponent;
